/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CampaignsIndexQueryParams, CampaignsIndexResponse } from '../types/CampaignsIndex'

/**
 * GET /campaigns
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignController.php CampaignController::index
 */
export async function campaignsIndex(
	params?: CampaignsIndexQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignsIndexResponse>> {
	return axiosInstance.get('/campaigns', { params, ...config })
}
